import {toInteger} from 'lodash';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {PortfolioService} from '../service/portfolio.service';
import {Keys, StorageService} from '../service/storage.service';
import {PreferencesService} from '../service/preferences.service';
import {PreferredCategories} from '../model/portfolio-preferences.model';
import {AutoInvestPortfolioCreationData} from '../model/portfolio-creation-data/auto-invest-portfolio-creation.data';
import {ManualInvestPortfolioCreationData} from '../model/portfolio-creation-data/manual-invest-portfolio-creation-data.model';
import * as uuid from 'uuid/v4';

@Injectable()
export class InvestmentNavigator {
    private readonly router: Router;
    private readonly portfolioService: PortfolioService;
    private readonly storageService: StorageService;
    private readonly preferencesService: PreferencesService;

    constructor(router: Router, portfolioService: PortfolioService, storageService: StorageService, preferencesService: PreferencesService) {
        this.router = router;
        this.portfolioService = portfolioService;
        this.storageService = storageService;
        this.preferencesService = preferencesService;
    }

    public async navigateToManualInvestListingPage(portfolioAmount: number | string): Promise<void> {
        const tempPortfolioId = uuid();
        const portfolioCreationData = new ManualInvestPortfolioCreationData(tempPortfolioId, toInteger(portfolioAmount));
        await this.portfolioService.createOrUpdateLocalPortfolioCreationData(portfolioCreationData);
        await this.router.navigate([`/manual-invest/${tempPortfolioId}`]);
    }

    public async navigateToAutoInvest(portfolioAmount: number | string) {
        const tempPortfolioId = uuid();
        const userId = this.storageService.getItem(Keys.PROFILE_ID);
        const preferences = await this.preferencesService.getUserPreferences(userId);
        const defaultPreferredCategories = <PreferredCategories[]>[{
            ratingList: Array.from(preferences.preferredRatings)
        }];
        const portfolioCreationData = new AutoInvestPortfolioCreationData(tempPortfolioId, toInteger(portfolioAmount), defaultPreferredCategories);
        await this.portfolioService.createOrUpdateLocalPortfolioCreationData(portfolioCreationData);
        await this.router.navigate([`/auto-invest/${tempPortfolioId}`]);
    }
}